import React, { useContext, useEffect, useState } from "react";
import classnames from "classnames";
import { useNode, useEditor } from "@craftjs/core";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import icon from "./icon";
import { ContentLockerPopupSettings } from "./settings";
import { RichTextInput } from "../../input";
import GrigoraCSSRenderer from "./../css-render";
import Toast from "../../toast/toast";
import { toast } from "react-toastify";
import { CorrectIcon } from "../../../assets/ui-icons";
import { GrigoraDashboardContext } from "../../dashboard/context";

export const ContentLockerPopup = (props) => {
  const { blockState, setBlockState } =
    useContext(GrigoraDashboardContext) ?? {};

  const {
    actions: { selectNode },
  } = useEditor();

  const {
    id,
    connectors: { connect, drag },
    selected,
    actions: { setProp },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    title = "Enjoying our content?",
    subtitle = "Please subscribe to continue",
    buttonText = "Subscribe",
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-content-locker-popup": true,
      [`content-locker-popup-${id}`]: id,
    },
    blockProps.className,
  );

  useEffect(() => {
    if (selected) {
      return;
    }
  }, [selected]);

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__ContentLockerPopup(
        id,
        props,
      )}`}</style>

      {/* Preview in editor */}
      <div className="g-content-locker-popup__preview">
        <div className="g-content-locker-popup__preview-heading">
          Content Locker Popup
        </div>
        <div className="g-content-locker-popup__preview-text">
          Popup will be shown when users scroll to this point
        </div>
        <button
          className="g-content-locker-popup__preview-button"
          onClick={() => {
            setBlockState(id, "is-opened", true);
          }}
        >
          Show Popup
        </button>
      </div>

      {/* Popup overlay */}
      <div
        className={`g-content-locker-popup__overlay ${
          blockState?.(id)?.["is-opened"] ? "is-opened" : ""
        }`}
        onClick={() => {
          setBlockState(id, "is-opened", false);
        }}
      >
        <div
          className={`g-content-locker-popup__card ${
            blockState?.(id)?.["is-opened"] ? "is-opened" : ""
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="g-content-locker-popup__title-container">
            <RichTextInput
              tagName="div"
              value={title}
              onChange={(title) => {
                setProp((props) => {
                  props.title = title;
                  return props;
                }, 500);
              }}
              placeholder="Enjoying our content?"
            />
          </div>
          <div className="g-content-locker-popup__subtitle-container">
            <RichTextInput
              tagName="div"
              value={subtitle}
              onChange={(subtitle) => {
                setProp((props) => {
                  props.subtitle = subtitle;
                  return props;
                }, 500);
              }}
              placeholder="Please subscribe to continue"
            />
          </div>
          <form
            className="g-content-locker-popup__form"
            onSubmit={(e) => e.preventDefault()}
          >
            <input
              type="email"
              className="g-content-locker-popup__input"
              placeholder="Email"
              disabled
            />
            <div className="g-content-locker-popup__button-container">
              <button>
                <RichTextInput
                  value={buttonText}
                  onChange={(e) =>
                    setProp((props) => (props.buttonText = e), 500)
                  }
                  tagName="span"
                  linkNotAllowed={true}
                  onLinkPaste={(url) => {
                    if (!url) {
                      return;
                    }

                    if (url.href) {
                      setProp((props) => (props.link = url.href), 500);

                      toast.success(
                        <Toast title={"Link Applied To Button"} />,
                        {
                          icon: <CorrectIcon />,
                        },
                      );
                    }
                  }}
                />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

ContentLockerPopup.displayName = "ContentLockerPopup";

ContentLockerPopup.craft = {
  name: "Popup Content Locker",
  props: {},
  related: {
    settings: ContentLockerPopupSettings,
    icon: icon,
    supports: ["grigora/custom-class", "grigora/custom-id"],
    category: "content-locker",
  },
  custom: {
    name: "Popup Content Locker",
    slug: "grigora/content-locker-popup",
  },
};
